/* eslint-disable no-unused-expressions */
/* eslint-disable react/prop-types */
/* eslint-disable import/no-named-as-default-member */
import React, { useContext, useState } from 'react';
import {
  Box, Button, Grid, makeStyles, TextField, Typography,
  MenuItem, Radio, RadioGroup, FormControl, FormControlLabel, FormLabel,
} from '@material-ui/core';
import { Phone } from '@material-ui/icons';
import {
  CityValidation, EmailValidation, LastNameValidation, PhoneValidation,
} from '../functions/FormValidation';
import { ActivityOptions } from '../functions/Options';
import Hubspot from '../functions/Hubspot';
import WhatsappIcon from '../atoms/icons/WhatsappIcon';
import TextFieldStatus from '../atoms/TextFieldStatus';
import AutocompleteCityUF from './AutocompleteCityUF';
import MaskedTextField from '../molecules/MaskedTextField';
import InputWrap from '../atoms/InputWrap';
import { NotificationModalContext } from '../../contexts/NotificationModalContext';

class FormValidator {
  static validateName(name) {
    if (!name) {
      return 'Nome é obrigatório';
    }
    try {
      // if (!LastNameValidation({ firstname: name })) {
      //   return 'Nome inválido';
      // }
      return null;
    } catch (e) {
      return e.message || 'Nome inválido';
    }
  }

  static validateEmail(email) {
    if (!email) {
      return 'E-mail é obrigatório';
    }
    try {
      if (!EmailValidation({ email })) {
        return 'E-mail inválido';
      }
      return null;
    } catch (e) {
      return e.message || 'E-mail inválido';
    }
  }

  static validatePhone(phone) {
    if (!phone) {
      return 'Telefone é obrigatório';
    }
    try {
      if (!PhoneValidation({ phone })) {
        return 'Telefone inválido';
      }
      return null;
    } catch (e) {
      return e.message || 'Telefone inválido';
    }
  }

  static validateCity(city) {
    if (!city) {
      return 'Informe a cidade.';
    }
    try {
      if (!CityValidation({ city })) {
        return 'Informe a cidade.';
      }
      return null;
    } catch (e) {
      return e.message || 'Informe a cidade.';
    }
  }

  static validateState(state) {
    if (!state) {
      return 'Informe a cidade.';
    }
    try {
      if (!CityValidation({ city: state })) {
        return 'Informe a cidade.';
      }
      return null;
    } catch (e) {
      return e.message || 'Informe a cidade.';
    }
  }

  static validateCityName(cityName) {
    if (!cityName) {
      return 'Informe a cidade.';
    }
    try {
      if (!CityValidation({ city: cityName })) {
        return 'Informe a cidade.';
      }
      return null;
    } catch (e) {
      return e.message || 'Informe a cidade.';
    }
  }

  static validateActivity(activity) {
    if (!activity || activity.trim() === '') {
      return 'Escolha a atividade.';
    }
    return null;
  }

  static validateBillingExpectation(billingExpectation) {
    if (!billingExpectation) {
      return 'Selecione uma das opções de faturamento.';
    }
    return null;
  }

  static validateField(fieldName, value) {
    switch (fieldName) {
      case 'firstname':
        return this.validateName(value);
      case 'email':
        return this.validateEmail(value);
      case 'phone':
        return this.validatePhone(value);
      case 'city':
        return this.validateCity(value);
      case 'cityName':
        return this.validateCityName(value);
      case 'state':
        return this.validateState(value);
      case 'activity':
        return this.validateActivity(value);
      case 'monthly_billing_expectation':
        return this.validateBillingExpectation(value);
      default:
        return null;
    }
  }

  static validateAll(data) {
    const errors = {};

    const nameError = this.validateName(data.firstname);
    if (nameError) errors.firstname = nameError;

    const emailError = this.validateEmail(data.email);
    if (emailError) errors.email = emailError;

    const phoneError = this.validatePhone(data.phone);
    if (phoneError) errors.phone = phoneError;

    const cityError = this.validateCity(data.city);
    if (cityError) errors.city = cityError;

    const cityNameError = this.validateCityName(data.cityName);
    if (cityNameError) errors.cityName = cityNameError;

    const stateError = this.validateState(data.state);
    if (stateError) errors.state = stateError;

    const activityError = this.validateActivity(data.activity);
    if (activityError) errors.activity = activityError;

    const billingError = this.validateBillingExpectation(data.monthly_billing_expectation);
    if (billingError) errors.monthly_billing_expectation = billingError;

    return errors;
  }
}

const useStyles = makeStyles(() => ({
  select: {
    '& .MuiSelect-icon': {
      right: '24px',
    },
  },
  radio: {
    color: '#36344B',
    padding: 0,
    '&.Mui-checked': {
      color: '#4FA050',
    },
    '& .MuiSvgIcon-root': {
      width: '16px',
      height: '16px',
    },
  },
  button: {
    position: 'relative',
    width: '100%',
    background: '#0093F5',
    '&:hover': {
      background: '#0673BC',
    },
    '&:disabled': {
      background: '#BFD4E3',
    },

    '& .MuiButton-label': {
      color: '#FFFFFF',
    },
  },
}));

/**
 * @param {{
 *  onSuccess?: () => void,
 *  tagPhone?: () => void,
 *  tagWpp?: () => void,
 *  tagWppId?: string,
 *  tagPhoneId?: string,
 *  originModal?: (open: boolean) => void,
 * }} props
 */
export default function OnExitWhoCostForm({
  onSuccess, originModal, tagWpp, tagPhone, tagWppId, tagPhoneId,
}) {
  const classes = useStyles();
  const [errors, setErrors] = useState({});
  const [errorRoot, setErrorRoot] = useState();
  const [data, setData] = useState({});
  const [isLoading, setIsLoading] = useState(false);
  const { setOpenModal } = useContext(NotificationModalContext);

  const changeData = (value, field) => {
    const newData = { ...data, [field]: value };
    setData(newData);

    const error = FormValidator.validateField(field, value);

    setErrors((prevErrors) => {
      const newErrors = { ...prevErrors };

      if (error) {
        newErrors[field] = error;
      } else {
        delete newErrors[field];
      }
      return newErrors;
    });
  };

  const isError = Object.keys(errors).length > 0 || isLoading || !data.firstname || !data.email
    || !data.phone || !data.city || !data.cityName || !data.state
    || !data.activity || !data.monthly_billing_expectation;

  const validateForm = () => {
    const newErrors = FormValidator.validateAll(data);
    setErrors(newErrors);
    return newErrors;
  };

  const handleCityUFChange = (value) => {
    if (value) {
      const updates = {};

      if (value.code) updates.city = value.code;
      if (value.name) updates.cityName = value.name;
      if (value.stateInitial) updates.state = value.stateInitial;

      const newData = { ...data, ...updates };
      setData(newData);

      Object.entries(updates).forEach(([key, val]) => {
        const error = FormValidator.validateField(key, val);
        if (error) {
          setErrors((prev) => ({ ...prev, [key]: error }));
        } else {
          setErrors((prev) => {
            const { [key]: _, ...rest } = prev;
            return rest;
          });
        }
      });
    } else {
      const resetFields = {
        ...data, city: '', cityName: '', state: '',
      };
      setData(resetFields);

      setErrors((prev) => {
        const {
          city, cityName, state, ...rest
        } = prev;
        return rest;
      });
    }
  };

  const disabled = Object.keys(errors).length > 0 || isLoading || Object.keys(data).length === 0;

  /**
   * @param {"Via Whatsapp" | "Via Ligação"} customerServiceType
   */
  const handleSubmit = async (customerServiceType) => {
    setErrorRoot(undefined);
    const validationErrors = validateForm();

    if (Object.keys(validationErrors).length > 0) {
      setErrors(validationErrors);
      return;
    }
    setIsLoading(true);

    try {
      await Hubspot.sendToHubspotForm('abrir-empresa', {
        ...data,
        customer_service: customerServiceType,
      });
      setIsLoading(false);
      if (!isError) {
        setData({
          firstname: '', email: '', phone: '', city: '', state: '', activity: '', cityName: '', monthly_billing_expectation: '',
        });
        setErrors({});
      }
      if (customerServiceType === 'Via Whatsapp') {
        originModal && originModal(false);
        window.location.href = `https://api.whatsapp.com/send/?phone=${process.env.GATSBY_WHATSAPP_BUSINESS}&text=Falar%20com%20Especialista&type=phone_number&app_absent=0`;
      } else {
        onSuccess();
      }
    } catch (error) {
      setErrorRoot('Desculpe, ocorreu um erro. Tente novamente mais tarde!');
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <form>
      <Typography style={{ paddingBottom: '16px' }}>
        Dados pessoais
      </Typography>
      <Box style={{ paddingBottom: '36px' }}>
        <InputWrap>
          <TextField
            label="Nome"
            name="firstname"
            value={data.firstname}
            onChange={(e) => changeData(e.target.value, 'firstname')}
            error={Boolean(errors.firstname)}
            helperText={errors.firstname}
            placeholder="Nome completo"
            InputLabelProps={{
              shrink: true,
              error: false,
              focused: false,
            }}
            InputProps={{
              endAdornment: (
                <TextFieldStatus
                  error={Boolean(errors.firstname)}
                  value={data.firstname && !errors.firstname}
                />
              ),
            }}
          />

          <TextField
            label="E-mail"
            name="email"
            type="email"
            value={data.email}
            onChange={(e) => changeData(e.target.value, 'email')}
            error={Boolean(errors.email)}
            helperText={errors.email}
            disabled={isLoading}
            placeholder="seu_email@mail.com.br"
            InputLabelProps={{
              shrink: true,
              error: false,
              focused: false,
            }}
            InputProps={{
              endAdornment: (
                <TextFieldStatus
                  error={Boolean(errors.email)}
                  value={data.email && !errors.email}
                />
              ),
            }}
          />

          <MaskedTextField
            onChange={(e) => changeData(e.target.value, 'phone')}
            mask="+55 (99) 99999-9999"
            textFieldProps={{
              label: 'Telefone',
              name: 'phone',
              type: 'tel',
              value: data.phone,
              floating: true,
              error: Boolean(errors.phone),
              helperText: errors.phone,
            }}
            placeholder="+55 (DDD) 00000-0000"
            InputLabelProps={{
              shrink: true,
              error: false,
              focused: false,
            }}
            InputProps={{
              disabled: isLoading,
              endAdornment: (
                <TextFieldStatus
                  error={Boolean(errors.phone)}
                  value={data.phone && !errors.phone}
                />
              ),
            }}
          />

          <AutocompleteCityUF
            onChange={(value) => handleCityUFChange(value)}
            value={{
              stateInitial: data.state,
              code: data.city,
              name: data.cityName,
            }}
            placeholder="Ex: São Paulo"
            InputLabelProps={{
              shrink: true,
              error: false,
              focused: false,
            }}
            InputProps={{
              endAdornment: (
                <TextFieldStatus
                  error={Boolean(errors.city)}
                  value={data.city && !errors.city}
                />
              ),
            }}
            error={Boolean(errors.city)}
            helperText={errors.city}
            disabled={isLoading}
          />
          <TextField
            label="Qual será a atividade? *"
            name="activity"
            value={data.activity || ''}
            onChange={(e) => changeData(e.target.value, 'activity')}
            disabled={isLoading}
            className={classes.select}
            error={Boolean(errors.activity)}
            helperText={errors.activity}
            InputLabelProps={{
              shrink: true,
              error: false,
              focused: false,
            }}
            InputProps={{
              endAdornment: (
                <TextFieldStatus
                  error={Boolean(errors.activity)}
                  value={data.activity && !errors.activity}
                />
              ),
            }}
            select
            SelectProps={{
              displayEmpty: true,
              renderValue: (selected) => {
                if (!selected) {
                  return (
                    <span style={{ color: 'rgba(0, 0, 0, 0.3)' }}>
                      Ex: programador, designer
                    </span>
                  );
                }
                return data.activity;
              },
            }}
          >
            {ActivityOptions.map((option) => (
              <MenuItem key={option.value} value={option.value}>
                {option.label}
              </MenuItem>
            ))}
          </TextField>
          <FormControl
            component="fieldset"
            error={Boolean(errors.monthly_billing_expectation)}
            disabled={isLoading}
            style={{ width: '100%' }}
          >
            <FormLabel
              component="legend"
              style={{
                fontSize: '0.75rem',
                fontWeight: 400,
                transform: 'none',
                color: 'rgba(0, 0, 0, 0.54)',
              }}
            >
              Qual a sua expectativa de faturamento mensal? *
            </FormLabel>
            <RadioGroup
              row
              name="monthly_billing_expectation"
              value={data.monthly_billing_expectation || ''}
              onChange={(e) => changeData(e.target.value, 'monthly_billing_expectation')}
              style={{ gap: '2px', marginTop: '8px' }}
            >
              <FormControlLabel
                value="Até R$ 6 mil"
                style={{ marginLeft: 0 }}
                control={<Radio className={classes.radio} style={{ marginRight: '8px' }} />}
                label={<Typography style={{ fontSize: '0.75rem', color: '#383743' }}>Até R$ 6 mil</Typography>}
              />
              <FormControlLabel
                value="Acima de R$ 6 mil"
                style={{ marginLeft: 0 }}
                control={<Radio className={classes.radio} style={{ marginRight: '8px' }} />}
                label={<Typography style={{ fontSize: '0.75rem', color: '#383743' }}>Acima de R$ 6 mil</Typography>}
              />
            </RadioGroup>
            {errors.monthly_billing_expectation && (
              <Typography variant="caption" style={{ color: '#f44336' }}>
                {errors.monthly_billing_expectation}
              </Typography>
            )}
          </FormControl>
        </InputWrap>
      </Box>

      {errorRoot && <Typography component="span" style={{ color: '#D12E26' }}>{errorRoot}</Typography>}

      <Typography style={{ marginBottom: '10px', color: '#383743' }}>
        Como você prefere ser atendido?
      </Typography>

      <Grid container spacing={4}>
        <Grid item xs={12} sm={6}>
          <Button
            id={tagWppId}
            className={classes.button}
            disabled={disabled}
            onClick={() => {
              tagWpp()
              handleSubmit('Via Whatsapp')}}
          >
            <WhatsappIcon
              height="20px"
              width="20px"
              style={{
                position: 'absolute', top: '50%', translate: '0 -40%', width: '20px', left: '18px',
              }}
            />
            VIA WHATSAPP
          </Button>
        </Grid>
        <Grid item xs={12} sm={6}>
          <Button
            id={tagPhoneId}
            className={classes.button}
            disabled={disabled}
            onClick={() => {
              tagPhone()
              handleSubmit('Via Ligação')}}
          >
            <Phone style={{ position: 'absolute', left: '18px' }} />
            VIA LIGAÇÃO
          </Button>
        </Grid>
      </Grid>
    </form>
  );
}
